const ensureSwiperLoaded = () => {
  if (typeof Swiper !== "undefined") {
    return Promise.resolve(Swiper);
  }

  if (window.__swiperLoaderPromise) {
    return window.__swiperLoaderPromise;
  }

  const swiperBundleUrl = window.themeAssets?.swiperBundleUrl;
  if (!swiperBundleUrl) {
    return Promise.reject(new Error("Missing Swiper bundle URL"));
  }

  window.__swiperLoaderPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${swiperBundleUrl}"]`
    );

    if (existingScript) {
      if (typeof Swiper !== "undefined") {
        resolve(Swiper);
        return;
      }
      existingScript.addEventListener("load", () => resolve(Swiper), {
        once: true,
      });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = swiperBundleUrl;
    script.defer = true;
    script.onload = () => resolve(Swiper);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return window.__swiperLoaderPromise;
};

const cwsHomeSlideshow = () => {
  const homeSlider = document.querySelector(".swiper-home");
  const logosSlider = document.querySelector(".swiper--logos");

  if (!homeSlider && !logosSlider) {
    return;
  }

  const initSliders = () => {
    if (homeSlider) {
      const playBtn = document.querySelectorAll(".slideshow-play");
      const pagination = document.querySelector(".swiper-home .swiper-pagination");

      new Swiper(".swiper-home", {
        autoplay: {
          delay: 7000,
        },
        loop: true,
        pagination: {
          el: ".slideshow-pagination",
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        lazy: true,
        on: {
          init: () => {
            const activeSlide = document.querySelectorAll(
              ".swiper-slide-active .animation-el"
            );

            activeSlide.forEach((el, index) => {
              setTimeout(() => {
                el.classList.add("animated");
              }, 100 * index);
            });
          },
          transitionStart: () => {
            const allElements = document.querySelectorAll(
              ".swiper-home .animation-el"
            );
            const activeSlide = document.querySelectorAll(
              ".swiper-slide-active .animation-el"
            );

            allElements.forEach((el) => {
              el.classList.remove("animated");
            });

            activeSlide.forEach((el, index) => {
              setTimeout(() => {
                el.classList.add("animated");
              }, 100 * index);
            });
          },
        },
      });

      playBtn.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();

          const stop = btn.closest(".swiper-slide").querySelector(".stop-video");
          const video = btn.closest(".swiper-slide").querySelector("iframe");
          const src = video.getAttribute("src");

          video.style.cssText = "opacity: 1; visibility: visible;";
          stop.style.cssText = "opacity: 1; visibility: visible;";
          video.setAttribute("src", `${src}&autoplay=1`);

          if (pagination !== null) {
            pagination.style.display = "none";
          }

          stop.addEventListener("click", (event) => {
            event.preventDefault();

            video.style.cssText = "opacity: 0; visibility: hidden;";
            stop.style.cssText = "opacity: 0; visibility: hidden;";
            video.setAttribute("src", src);
            if (pagination !== null) {
              pagination.style.display = "";
            }
          });
        });
      });
    }

    if (logosSlider) {
      const slidesPerView = logosSlider.getAttribute("data-slides-per-view");

      new Swiper(".swiper--logos", {
        slidesPerView: 2,
        loop: false,
        spaceBetween: 15,
        navigation: {
          nextEl: ".logos-button-next",
          prevEl: ".logos-button-prev",
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
          992: {
            spaceBetween: 30,
            slidesPerView,
          },
        },
      });
    }
  };

  ensureSwiperLoaded().then(initSliders).catch(console.error);
};

const cwsReviews = () => {
  const reviewsSlider = document.querySelector(".swiper--reviews");
  const expertReviewsSlider = document.querySelector(".swiper--expert-reviews");
  const productReviewsSlider = document.querySelector(".swiper--products");

  const loadProductSlideBackground = (slide) => {
    if (!slide) {
      return;
    }

    const bgSrc = slide.getAttribute("data-bg-src");
    if (!bgSrc || slide.dataset.bgLoaded === "true") {
      return;
    }

    slide.style.backgroundImage = `url(${bgSrc})`;
    slide.dataset.bgLoaded = "true";
  };

  const loadProductSlideNeighbors = (swiper) => {
    if (!swiper?.slides?.length) {
      return;
    }

    const activeSlide = swiper.slides[swiper.activeIndex];
    loadProductSlideBackground(activeSlide);

    if (typeof swiper.slides[swiper.activeIndex + 1] !== "undefined") {
      loadProductSlideBackground(swiper.slides[swiper.activeIndex + 1]);
    }

    if (typeof swiper.slides[swiper.activeIndex - 1] !== "undefined") {
      loadProductSlideBackground(swiper.slides[swiper.activeIndex - 1]);
    }
  };

  if (!reviewsSlider && !expertReviewsSlider && !productReviewsSlider) {
    return;
  }

  const initSliders = () => {
    if (reviewsSlider) {
      new Swiper(".swiper--reviews", {
        slidesPerView: 1,
        autoHeight: false,
        loop: true,
        lazy: true,
        watchSlidesProgress: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".review-button-next",
          prevEl: ".review-button-prev",
        },
        breakpoints: {
          768: {
            autoHeight: true,
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      });
    }

    if (expertReviewsSlider) {
      new Swiper(".swiper--expert-reviews", {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: false,
        loop: true,
        navigation: {
          nextEl: ".review-button-next",
          prevEl: ".review-button-prev",
        },
        breakpoints: {
          768: {
            autoHeight: true,
          },
        },
      });
    }

    if (productReviewsSlider) {
      const initProductReviewsSlider = () => {
        const productSwiper = new Swiper(".swiper--products", {
          slidesPerView: 1,
          loop: true,
          autoHeight: false,
          navigation: {
            nextEl: ".product-slides-button-next",
            prevEl: ".product-slides-button-prev",
          },
          breakpoints: {
            768: {
              autoHeight: true,
            },
          },
          on: {
            init: (swiper) => {
              loadProductSlideNeighbors(swiper);
            },
            slideChangeTransitionStart: (swiper) => {
              loadProductSlideNeighbors(swiper);
            },
          },
        });

        loadProductSlideNeighbors(productSwiper);
      };

      if ("IntersectionObserver" in window) {
        const sliderObserver = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) {
              return;
            }

            observer.unobserve(entries[0].target);
            initProductReviewsSlider();
          },
          {
            rootMargin: "0px 0px 300px 0px",
          }
        );

        sliderObserver.observe(productReviewsSlider);
      } else {
        initProductReviewsSlider();
      }
    }
  };

  ensureSwiperLoaded().then(initSliders).catch(console.error);
};

const cwsMoveArrow = () => {
  const arrow = document.querySelector(".announcement-bar__message svg");
  const txt = document.querySelector(".announcement-bar__message p");

  if (arrow !== null) {
    txt.append(arrow);
    arrow.style.display = "inline-block";
  }
};

cwsMoveArrow();

document.addEventListener("DOMContentLoaded", () => {
  cwsReviews();
  cwsHomeSlideshow();
});